/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DollarIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DollarIcon({
  children,
  viewPath = "/DesignSystem/Svgs/DollarIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="DollarIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-Z3l1YW': alignSelf,'--mt-2-Z3l1YW': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z3l1YW': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z3l1YW': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z3l1YW': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z3l1YW': opacity,'--w-10-Z3l1YW': typeof width === 'number' ? `${width}px` : width,'--h-11-Z3l1YW': typeof height === 'number' ? `${height}px` : height,'--a-7-Z3l1YW': isAnimated ? animation : "none",'--sd-8-Z3l1YW': isAnimated ? strokeDashoffset : 0,'--sd-9-Z3l1YW': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="DollarIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M16 16c-1.6 0-2.9-1.3-2.9-2.9s1.3-2.9 2.9-2.9 2.9 1.3 2.9 2.9M16 16c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9s-2.9-1.3-2.9-2.9M16 7.1v3.1M16 21.8v3.1"
 style={{'--f-12-Z3l1YW': fill,'--s-13-Z3l1YW': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
<circle
  data-testid="DollarIcon.SvgCircle"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 cx={16}
 cy={16}
 r={12.8}
 style={{'--f-12-Z3l1YW': fill,'--s-13-Z3l1YW': stroke}}
 className={`views-block ${styles.SvgCircle}`}
/>
</svg>
{children}
</React.Fragment>)
}